import { Autocomplete, Box, Button, Drawer, Stack, TextField, Tooltip, Typography } from '@mui/material'
import React, { Component } from 'react'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import './RadRpts.css'
import { Colors } from '../../../Styles/Colors'
import { AmountsCard } from '../../../Components/CommonCards/CommonCards'
import { DataGrid } from '@mui/x-data-grid'
import CommonGridHeader from '../../../Components/Common Components/CommonComponents'
import { ImagePaths } from '../../../Utility/ImagePaths'
import { CurrencySymbol } from '../../../Utility/Constants'
import { DateTime } from 'luxon'
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { AmountFormat, formatDateAndTimeMeth2 } from '../../../Components/CommonFunctions/CommonFunctions'
import { localGetItem } from '../../../Utility/Services/CacheProviderService'

const genderList = [
  { label: "Male", value: "m" },
  { label: "Female", value: "f" },
  { label: "Transgender", value: "t" }
]
export default class RadPatientReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      patientReportData: [],
      totalBillAmount: 0,
      totalTests: 0,
      page: 0,
      pageSize: 10,
      loading: false,
      timeError: false,
      fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      dateIndex: 1,
      FilterOpen: false,
      isNewBilling: false,
      serviceName: [],
      serviceType: [],
      NewServiceName: [],
      NewServiceType: [],
      serviceNameList: [],
      serviceTypeList: [],
      gender: [],
      disableBtn: false,
      allServices: [],
      selectedServices: []
    }
  }

  componentDidMount() {
    this.getPatientReportData()
    this.setState({
      isNewBilling: localGetItem("isNewBilling") === "true" ? true : false
    })
    if (localGetItem("isNewBilling") !== "true") {
      this.getServiceConfigData();
    }else{
      this.getModuleList();
    }
  }

  GetInvestigationName = (smallCase = false) => {
    // this hits only in scopy, audiometry, radiology - for return module name for dynamic router
    const InvestigationName = localGetItem('investigation_name') ? localGetItem('investigation_name') : "Radiology"
    if (localGetItem('isNewBilling') !== "true") {
      return smallCase ? 'radiology' : `Radiology`
    } else if (InvestigationName) {
      return InvestigationName
    } else {
      return smallCase ? 'radiology' : `Radiology`
    }
  }

  getModuleList = () => {
    try {
      let serviceTypes = [];
      let allServices = [];

      RestAPIService.getAll(Serviceurls.NEW_SERVICE_LIST_REPORT)
        .then((response) => {
          if (response.data.status === 'success') {
            const ModuleData = response.data.data || {};

            let uniqueHeads = new Set(); // Store unique head names

            Object.keys(ModuleData).forEach(moduleType => {
              if (moduleType !== (JSON.parse(localGetItem('loggedInUserInfo'))?.module_name === "Investigation" ? this.GetInvestigationName() : "RADIOLOGY")) return; // Exclude IP Module

              ModuleData[moduleType].forEach(({ head_name, service_details }) => {
                //  Add only unique head names
                if (!uniqueHeads.has(head_name)) {
                  uniqueHeads.add(head_name);
                  serviceTypes.push({ head_name, service_details: service_details || [] });
                }

                if (service_details) {
                  service_details.forEach(({ service_name }) => {
                    //  Ensure unique service names
                    if (!allServices.some(s => s.service_name === service_name)) {
                      allServices.push({ service_name });
                    }
                  });
                }
              });
            });
            this.setState({
              serviceHeads: [...serviceTypes],
              allServices: [...allServices],
            });
          }
        })
        .catch((error) => {
          this.errorMessage(error.response.data.message || error.message)
        });
    } catch (error) {
      this.errorMessage(error.message);
    }
  };

  getServiceConfigData = () => {
    try {
      RestAPIService.getAll(Serviceurls.RAD_SERVICE_CONFIG)
        .then((response) => {
          if (response.data.status === 'success') {
            const filter_data = response?.data?.data?.reduce((acc, cur) => {
              acc?.serviceTypeData?.add(cur?.service_type);
              cur?.data?.forEach(item => acc?.serviceNameData?.add(item?.service_name));
              return acc;
            }, {
              serviceNameData: new Set(),
              serviceTypeData: new Set()
            })
            this.setState({
                serviceNameList: [...filter_data.serviceNameData],
                serviceTypeList: [...filter_data.serviceTypeData]
            })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPatientReportData = () => {
    try {
      let gender = [];
      this.state.gender.forEach(element => { gender.push(element.value) });
      let serviceName = []
      this.state.NewServiceName.forEach(element => { serviceName.push(encodeURIComponent(element.service_name)) });
      let serviceType = []
      this.state.NewServiceType.forEach(element => { serviceType.push(encodeURIComponent(element.head_name)) });
      let oldserType = []
      this.state.serviceType.forEach(element => { oldserType.push(encodeURIComponent(element)) });
      let oldserName = []
      this.state.serviceName.forEach(element => { oldserName.push(encodeURIComponent(element)) });
      const baseUrl = (localGetItem('isNewBilling') === "true") ? (localGetItem('is_investigation_module') === "true" ? Serviceurls.NEW_INVESTIGATION_PATIENT_REPORT : Serviceurls.NEW_RAD_PATIENT_REPORT) : Serviceurls.RAD_PATIENT_REPORT;
      RestAPIService.getAll(baseUrl + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&service_type=${this.state.isNewBilling ? serviceType.join(";") : oldserType.join(";")}&service_name=${this.state.isNewBilling ? serviceName.join(";") : oldserName.join(";")}&gender=${gender}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              patientReportData: response.data.data,
              totalBillAmount: response.data.total_amount,
              totalTests: response.data.total_test
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPatientReportDataexcel = () => {
    if (this.state.disableBtn) return;
    try {
      this.setState({ disableBtn: true});
      let gender = [];
      this.state.gender.forEach(element => { gender.push(element.value) });
      let serviceName = []
      this.state.NewServiceName.forEach(element => { serviceName.push(element.service_name) });
      let serviceType = []
      this.state.NewServiceType.forEach(element => { serviceType.push(element.head_name) });
      let oldserType = []
      this.state.serviceType.forEach(element => { oldserType.push(element) });
      let oldserName = []
      this.state.serviceName.forEach(element => { oldserName.push(element) });
      const baseUrl = (localGetItem('isNewBilling') === "true") ? (localGetItem('is_investigation_module') === "true" ? Serviceurls.NEW_INVESTIGATION_PATIENT_REPORT : Serviceurls.NEW_RAD_PATIENT_REPORT) : Serviceurls.RAD_PATIENT_REPORT;
      RestAPIService.excelGet(baseUrl + `?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&service_type=${this.state.isNewBilling ? serviceType.join(";") : oldserType.join(";")}&service_name=${this.state.isNewBilling ? serviceName.join(";") : oldserName.join(";")}&gender=${gender}&export_type=excel`)
        .then((response) => {
          if (response.data) {
            var pom = document.createElement('a');
            var csvContent = response.data; //here we load our csv data 

            let filename = response.headers["content-disposition"]?.split("filename=")[1]

            var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' });
            var url = URL.createObjectURL(blob);
            pom.href = url;
            pom.setAttribute('download', filename ? filename : 'registry.xlsx');
            pom.click();
            this.setState({ disableBtn: false});
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error.message);
           this.setState({ disableBtn: false});
        })
    } catch (error) {
      this.errorMessage("Error occured on print")
       this.setState({ disableBtn: false});
    }
  }

  getPatientReportPrint = () => {
    try {
      const baseUrl = (localGetItem('isNewBilling') === "true") ? (localGetItem('is_investigation_module') === "true"  ? Serviceurls.NEW_INVESTIGATION_PATIENT_REPORT : Serviceurls.NEW_RAD_PATIENT_REPORT) : Serviceurls.RAD_PATIENT_REPORT;
      RestAPIService.getAll(baseUrl + `?export=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  FilterDate = (from, to, index) => {
    this.setState({
      fromDate: from,
      toDate: to,
      dateIndex: index
    })
  }

  closeFilter = () => {
    this.setState({
      FilterOpen: false
    })
  }

  renderAutoComplete = (label, statekey, list) => {
    return (
      <Box className='eMed_rts_dropdown'>
        <Autocomplete
          multiple
          limitTags={1}
          size='small'
          options={list}
          getOptionLabel={(option) => (option)}
          value={this.state[statekey]}
          onChange={(event, newValue) => {
            this.setState({
                [statekey]: newValue
            })
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
            />
          )}
        />
      </Box>)
  }

  renderFilterScreen = () => {
    const { t } = this.props
    return (
      <Box component={"div"} className='eMed_rts_filter_container'>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>{'Filter'}</Typography>
          <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
          </Button>
        </Box>
        <Box className='eMed_rts_middle'>
          <Box className='eMed_date_filter'>
            <CommonDatePicker
              FromDate={this.state.fromDate}
              ToDate={this.state.toDate}
              DateIndex={this.state.dateIndex}
              SelectedDates={this.FilterDate.bind(this)}
              HideAllMenu={true} />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              multiple
              limitTags={1}
              size='small'
              options={genderList?.map((item) => item)}
              getOptionLabel={(option) => (option?.label)}
              value={this.state.gender}
              onChange={(event, newValue) => {
                this.setState({ gender: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Select Gender"}
                />
              )}
            />
          </Box>
          {this.state.isNewBilling ?
            <>
              <Box className='eMed_rts_dropdown'>
                <Autocomplete
                  multiple
                  limitTags={1}
                  size='small'
                  options={this.state.serviceHeads}
                  getOptionLabel={(option) => (option?.head_name)}
                  value={this.state?.NewServiceType}
                  onChange={(event, newValue) =>
                    this.setState({
                      NewServiceType: newValue
                    }, () => {
                      const filteredServices = newValue.flatMap(
                        head => head?.service_details || []
                      );
                      this.setState({
                        selectedServices: filteredServices
                      });
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Select Service Type"}
                    />
                  )}
                />
              </Box>
              <Box className='eMed_rts_dropdown'>
                <Autocomplete
                  multiple
                  limitTags={1}
                  size='small'
                  options={this.state.NewServiceType?.length > 0 ? this.state.selectedServices : this.state.allServices}
                  getOptionLabel={(option) => (option?.service_name)}
                  value={this.state?.NewServiceName}
                  onChange={(event, newValue) => {
                    this.setState({
                      NewServiceName: newValue
                    })
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Select Service Name"}
                    />
                  )}
                />
              </Box>
            </>
            :
            <>  {this.renderAutoComplete("Select Service Type", "serviceType", this.state.serviceTypeList)}
              {this.renderAutoComplete("Select Service Name", "serviceName", this.state.serviceNameList)}</>
          }
        </Box>
        <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
          <Button variant='outlined' size="small"
            onClick={() => {
              this.setState({
                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                dateIndex: 1,
                gender: [],
                serviceName: [],
                serviceType: [],
                NewServiceName: [],
                NewServiceType: [],
              },
                () => this.getPatientReportData()
              )
            }}
            id="eMed_Config_btn">{"Clear"}</Button>
          <Button variant='contained' size="small"
            onClick={() => {
              this.setState({ FilterOpen: false }, () => this.getPatientReportData())
            }}
            id="eMed_Config_btn">{"Search"}</Button>
        </Stack>
      </Box>
    )
  }

  render() {
    this.state.patientReportData?.forEach((element, index) => element.sno = index + 1)
    const column = [
      { field: 'sno', headerName: 'S.No', flex: 0.05 },
      {
        field: 'invoice_date', headerName: 'Date And Time', flex: 0.143, align: 'center', headerAlign: 'center',
        renderCell: (params) => (<Box component={'div'} emed_tid={'rad_rpts_date_pat'}>{params?.row?.invoice_date ? formatDateAndTimeMeth2(params?.row?.invoice_date) : '-'}</Box>)
      },
      {
        field: 'name', headerName: 'Patient Details', flex: 0.236,
        renderCell: (params) => (<Box component={'div'} emed_tid='rad_bill_trns_pat_name_canc'>
          <Typography fontSize={'0.9vw'} fontWeight={600}>{params?.row?.name ?
            params?.row?.name?.length > 15 ?
              <Tooltip placement='top' title={params?.row?.name + "" + params?.row?.patient_age_str + '/' + params?.row?.gender[0]}><div style={{ fontWeight: 600, fontSize: '0.9vw' }}>{params?.row?.name?.slice(0, 15) + '...' + params?.row?.patient_age_str + '/' + params?.row?.gender[0]}</div></Tooltip> :
              (params?.row?.name + "" + params?.row?.patient_age_str + '/' + params?.row?.gender[0]) : '-'}</Typography>
          <Typography fontSize={'0.8vw'} color={Colors.grayShade}>{params?.row?.patient_account_number ? params?.row?.patient_account_number : '-'}</Typography>
        </Box>), valueGetter: (params) => {
          const name = params?.row?.name || "";
          const number = params?.row?.patient_account_number || "";
          return `${name} ${number}`;
        }
      },
      {
        field: 'service_name', headerName: 'Service Name', flex: 0.143,
        renderCell: (params) => (<Box component={'div'} emed_tid={'rad_rpts_ser_name_pat'}>{params?.row?.service_name ?
          params?.row?.service_name?.length > 15 ?
            <Tooltip placement='top' title={params?.row?.service_name}><Typography>{params?.row?.service_name?.slice(0, 15) + '...'}</Typography></Tooltip> :
            <Typography>{params?.row?.service_name}</Typography> : '-'}</Box>)
      },
      {
        field: 'service_type', headerName: 'Service type', flex: 0.143,
        renderCell: (params) => (<Box component={'div'} emed_tid={'rad_rpts_ser_type_pat'}>{params?.row?.service_type ?
          params?.row?.service_type?.length > 15 ?
            <Tooltip placement='top' title={params?.row?.service_type}><Typography>{params?.row?.service_type?.slice(0, 15) + '...'}</Typography></Tooltip> :
            <Typography>{params?.row?.service_type}</Typography> : '-'}</Box>)
      },
      {
        field: 'amount', headerName: `Amount (${CurrencySymbol})`, flex: 0.143, type: 'number',
        renderCell: (params) => (<Box component={'div'} emed_tid={'rad_rpts_amt_pat'}>{AmountFormat(params?.row?.amount ? params?.row?.amount : 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
      },
      // {
      //   field: 'action', headerName: 'Action', flex: 0.143, headerAlign: 'center', align: 'center',
      //   renderCell: (params) => (<Box component={'div'} emed_tid={'rad_rpts_act_pat'}>
      //     <Tooltip placement='top' title={'Print'} arrow>
      //       <Button className='Common_Btn_Min_Width'>
      //         <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'2vw'} width={'2vw'} />
      //       </Button>
      //     </Tooltip>
      //   </Box>)
      // },
    ]
    return (
      <Box component={'div'}>
        <Box component={'div'} className='rad_Rpts_container' sx={{ backgroundColor: Colors.Background }}>
          <Box component={'div'} className='rad_rpts_header_card'>
            <Box component={'div'} className='rad_rpts_cards'>
              {AmountsCard("Total Test", this.state.totalTests, true, "white", false, null, "rad_pat_totl_tst")}
              {AmountsCard("Total Amount", this.state.totalBillAmount, false, "white", false, null, 'rad_pat_amt')}
            </Box>
            <Box component={'div'} className='rad_rpts_btns'>
              <Tooltip placement='top' title={'Filter'} arrow>
                <Button className='Common_Btn_Min_Width' sx={{ height: '2vw' }} emed_tid='rad_rpts_flt_pat'
                  onClick={() => this.setState({ FilterOpen: true })}
                >
                  <Box component={'img'} src={ImagePaths.Filter.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip>
              {/* <Tooltip placement='top' title={'Print'} arrow>
                <Button className='Common_Btn_Min_Width' sx={{ height: '2vw' }} emed_tid='rad_rpts_prt_pat'
                  disabled={this.state.disableBtn}
                  onClick={() => this.getPatientReportPrint()}
                >
                  <Box component={'img'} src={ImagePaths.LabPrintIcon.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip> */}
              <Tooltip placement='top' title={'Export'} arrow>
                <Button className='Common_Btn_Min_Width' sx={{ height: '2vw' }} emed_tid='rad_rpts_exp_pat' onClick={() => {
                  if (this.state.patientReportData?.length > 0) {
                    this.getPatientReportDataexcel()
                  } else {
                    this.errorMessage("No data to export")
                  }
                } }>
                  <Box component={'img'} src={ImagePaths.ExportIcon.default} height={'2vw'} width={'2vw'} />
                </Button>
              </Tooltip>
            </Box>
          </Box>
          <Box component={'div'} className='rad_rpts_content_card'>
            <DataGrid
              sx={{ backgroundColor: Colors.white }}
              columns={column}
              rows={this.state.patientReportData}
              getRowId={(row) => row['sno']}
              page={this.state.page}
              pageSize={this.state.pageSize}
              localeText={{
                toolbarColumns: "",
                toolbarDensity: "",
                toolbarExport: "",
                toolbarFilters: "",
                toolbarExportPrint: ""
              }}
              components={{
                Toolbar: CommonGridHeader.CommonToolBar,
                NoRowsOverlay: () => (
                  <Box className='eMed_conf_nodata'>
                    {'No Records To Be Shown'}
                  </Box>
                )
              }}
              onPageChange={(newPage) => { this.setState({ page: newPage }) }}
              onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
              rowsPerPageOptions={[10, 20, 30]}
              pagination
              headerHeight={40}
              disableSelectionOnClick
              loading={this.state.loading}
            />
          </Box>
        </Box>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.closeFilter }}
        >
          {this.renderFilterScreen()}
        </Drawer>
      </Box>
    )
  }
}
